// translations/translations.js
export const translations = {
  en: {
    home: "Home",
    courses: "Courses",
    work: "Work",
    channel: "Channel",
    contact: "Contact",
    profile: "Profile",
    studentWork: "Our Student Work",
    course: {
      title: "Special Course",
      price: "4000",
      instructor: "Eng. Mahmoud ELKhawaga",
      booknow: "Book now",
      description:
        "This course covers four major programs: Photoshop, Illustrator, InDesign, and Premiere Pro. You'll learn everything from installation to mastering tools, specific use cases for photography, social media, digital prints, logo design, video editing, and more. The course duration is 80 days, with 40 videos and 40 Zoom sessions (live group workshops). Perfect for those looking to enhance their creative skills across different media.",
      curriculum: {
        Photoshop: {
          title: "Photoshop",
          lessons: [
            "Installation and Setup",
            "Program Interface and Tools Overview",
            "Photoshop for Photographers",
            "Photoshop for Social Media Design",
            "Photoshop for Digital Prints",
            "Photoshop for Banners and Large Prints",
          ],
        },
        Illustrator: {
          title: "Illustrator",
          lessons: [
            "Installation and Setup",
            "Interface and Tools Overview",
            "Logo Design",
            "2D Illustration",
            "3D Illustration",
          ],
        },
        InDesign: {
          title: "InDesign",
          lessons: [
            "Installation and Setup",
            "Interface and Tools Overview",
            "Inserting Covers, Master Pages, and Automatic Numbering",
            "Preparing Study Notes for All Subjects",
            "Preparing Books for All Subjects",
            "Simplified University Materials Preparation",
          ],
        },
        PremierePro: {
          title: "Premiere Pro",
          lessons: [
            "Installation and Setup",
            "Interface and Tools Overview",
            "Assembling a Video on the Timeline",
            "Cutting and Removing Unwanted Parts",
            "Installing and Using Plugins",
            "Applying Plugin Effects",
            "Preparing a Wedding Video",
            "Preparing an Educational Video",
          ],
        },
      },
    },
    footer: {
      designedBy: "Designed and Developed by",
      copyright: "Copyright ©",
    },
    contactSection: {
      title: "Get In Touch!",
      contactTitle: "Contact: Eng. Mahmoud ELKhawaga",
      formTitle: "Contact Us",
      nameLabel: "Name",
      emailLabel: "Email",
      mobileLabel: "Your contact Mobile Number",
      successMessage:
        "Sent successfully, you will be replied to as soon as possible.",
      errorMessage: "Failed to send, please try again later.",
      messageLabel: "Message",
      submitButton: "Send",
    },
    channel: "Channel",
    channelStats: {
      totalSubscribers: "Total Subscribers",
      youtubeCourses: "YouTube Courses (Videos)",
      youtubeViews: "YouTube Views",
      youtubeChannelStats: "YouTube Channel Stats",
      subscribers: "Subscribers",
      totalViews: "Total Views",
      visitChannel: "Visit our YouTube Channel",
    },
    authup: {
      title: "Sign Up",
      success: "User registered successfully!",
      error: "Error signing up.",
      firstNamePlaceholder: "First Name",
      lastNamePlaceholder: "Last Name",
      mobilePlaceholder: "Mobile Number",
      emailPlaceholder: "Email",
      passwordPlaceholder: "Password",
      genderPlaceholder: "Select Gender",
      maleOption: "Male",
      femaleOption: "Female",
      groupDetailsPlaceholder: "Group Details",
      signUpButton: "Sign Up",
      prompt: "Already have an account?",
      signInText: "Sign in here",
    },
    authin: {
      title: "Sign In",
      success: "User registered successfully!",
      error: "Error signing up.",
      firstNamePlaceholder: "First Name",
      lastNamePlaceholder: "Last Name",
      mobilePlaceholder: "Mobile",
      emailPlaceholder: "Email",
      passwordPlaceholder: "Password",
      signUpButton: "Sign iN",
      prompt: "don't have account?",
      signInText: "Sign up here",
    },
    auth: {
      profile: "Profile",
      logout: "Log Out",
      login: "Log In",
      username: "Username",
    },
  },
  ar: {
    home: "الرئيسية",
    courses: "الدورات",
    work: "الأعمال",
    channel: "القناة",
    contact: "تواصل",
    profile: "الملف الشخصي",
    studentWork: "أعمال طلابنا",
    course: {
      title: "دورة خاصة",
      instructor: "المهندس محمود الخواجة",
      booknow: "احجز الان",
      price: "4000 ",
      description:
        "تغطي هذه الدورة أربعة برامج رئيسية: Photoshop و Illustrator و InDesign و Premiere Pro. ستتعلم كل شيء من التثبيت إلى إتقان الأدوات، واستخدامات محددة للتصوير الفوتوغرافي، ووسائل التواصل الاجتماعي، والطباعة الرقمية، وتصميم الشعارات، وتحرير الفيديو، وأكثر من ذلك. مدة الدورة 80 يومًا، مع 40 فيديو و 40 جلسة Zoom (ورش عمل جماعية مباشرة). مثالي لمن يتطلعون لتعزيز مهاراتهم الإبداعية عبر وسائط مختلفة.",
      curriculum: {
        Photoshop: {
          title: "فوتوشوب",
          lessons: [
            "التثبيت والإعداد",
            "نظرة عامة على واجهة البرنامج والأدوات",
            "فوتوشوب للمصورين",
            "فوتوشوب لتصميم وسائل التواصل الاجتماعي",
            "فوتوشوب للطباعة الرقمية",
            "فوتوشوب للافتات والطباعة الكبيرة",
          ],
        },
        Illustrator: {
          title: "إليستريتور",
          lessons: [
            "التثبيت والإعداد",
            "نظرة عامة على الواجهة والأدوات",
            "تصميم الشعارات",
            "الرسم ثنائي الأبعاد",
            "الرسم ثلاثي الأبعاد",
          ],
        },
        InDesign: {
          title: "إن ديزاين",
          lessons: [
            "التثبيت والإعداد",
            "نظرة عامة على الواجهة والأدوات",
            "إدراج الأغطية، الصفحات الرئيسية، والترقيم التلقائي",
            "إعداد ملاحظات دراسية لجميع المواد",
            "إعداد كتب لجميع المواد",
            "تبسيط إعداد المواد الجامعية",
          ],
        },
        PremierePro: {
          title: "بريميير برو",
          lessons: [
            "التثبيت والإعداد",
            "نظرة عامة على الواجهة والأدوات",
            "تجميع فيديو على الجدول الزمني",
            "قص وإزالة الأجزاء غير المرغوب فيها",
            "تثبيت واستخدام الإضافات",
            "تطبيق تأثيرات الإضافات",
            "إعداد فيديو زفاف",
            "إعداد فيديو تعليمي",
          ],
        },
      },
    },
    footer: {
      designedBy: "صمم وطور بواسطة",
      copyright: "حقوق الطبع والنشر ©",
    },
    // New Contact Translations
    contactSection: {
      title: "تواصل معنا!",
      contactTitle: "تواصل مع: المهندس محمود الخواجة",
      formTitle: "اتصل بنا",
      nameLabel: "الاسم",
      emailLabel: "البريد الإلكتروني",
      mobileLabel: "رقم الهاتف للتواصل",
      successMessage: "تم الارسال بنجاح سيتم الرد فى اقرب وقت",
      errorMessage: "فشل الارسال حاول مره اخرى فى وقت لاحق",
      messageLabel: "الرسالة",
      submitButton: "إرسال",
    },
    channel: "القناة",
    channelStats: {
      totalSubscribers: "إجمالي المشتركين",
      youtubeCourses: "دورات يوتيوب (فيديوهات)",
      youtubeViews: "مشاهدات يوتيوب",
      youtubeChannelStats: "إحصائيات قناة يوتيوب",
      subscribers: "المشتركين",
      totalViews: "إجمالي المشاهدات",
      visitChannel: "زيارة قناتنا على يوتيوب",
    },
    authup: {
      title: "تسجيل حساب",
      success: "تم تسجيل المستخدم بنجاح!",
      error: "خطأ في التسجيل.",
      firstNamePlaceholder: "الاسم الأول",
      lastNamePlaceholder: "اسم العائلة",
      mobilePlaceholder: "رقم الهاتف",
      emailPlaceholder: "البريد الإلكتروني",
      passwordPlaceholder: "كلمة المرور",
      genderPlaceholder: "اختر النوع",
      maleOption: "ذكر",
      femaleOption: "أنثى",
      groupDetailsPlaceholder: "تفاصيل المجموعة",
      signUpButton: "تسجيل",
      prompt: "هل لديك حساب بالفعل؟",
      signInText: "سجل الدخول هنا",
    },
    authin: {
      title: "تسجيل حساب",
      success: "تم تسجيل المستخدم بنجاح!",
      error: "خطأ في التسجيل.",
      firstNamePlaceholder: "الاسم الأول",
      lastNamePlaceholder: "الاسم الأخير",
      mobilePlaceholder: "الهاتف",
      emailPlaceholder: "البريد الإلكتروني",
      passwordPlaceholder: "كلمة المرور",
      signUpButton: "تسجيل",
      prompt: "ليس لديك حساب؟",
      signInText: "سجل الان",
    },
    auth: {
      profile: "الملف الشخصي",
      logout: "تسجيل الخروج",
      login: "تسجيل الدخول",
      username: "اسم المستخدم",
    },
  },
};
